import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import GetAppIcon from '@material-ui/icons/GetApp';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LoadingProgress from 'common/components/progress/loading';
import AlertDialogSlide from 'common/components/dialog/dialog';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import * as XLSX from 'xlsx';

const statusLabels = {
  pending: 'Pendente',
  registered: 'Cadastrado',
  affiliated: 'Filiado',
  completed: 'Concluída',
};

class ReferralResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const actionId = this.props.location.query.action;
      const response = await axios.get(`${BASE_API}/referrals/${actionId}/export`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      this.setState({ data: response.data, loading: false });
    } catch (error) {
      console.error('Erro ao buscar relatório:', error);
      this.setState({ loading: false });
    }
  };

  exportToExcel = () => {
    const { data } = this.state;
    const rows = [];

    data.forEach((item) => {
      if (item.lucky_numbers && item.lucky_numbers.length > 0) {
        item.lucky_numbers.forEach((num) => {
          rows.push({
            'Número da Sorte': num.number,
            'Nome do Filiado (Indicador)': item.inviter_name,
            'CPF do Filiado': item.inviter_cpf,
            'Nome do Indicado': item.invited_name,
            'E-mail do Indicado': item.invited_email,
            'CPF do Indicado': item.invited_cpf,
            Status: statusLabels[item.status] || item.status,
            'Data de Indicação': item.indication_date
              ? new Date(item.indication_date).toLocaleDateString('pt-BR')
              : '',
            'Data de Conclusão': item.completion_date
              ? new Date(item.completion_date).toLocaleDateString('pt-BR')
              : '',
            'Data do Número': num.created_at
              ? new Date(num.created_at).toLocaleDateString('pt-BR')
              : '',
          });
        });
      } else {
        rows.push({
          'Número da Sorte': '',
          'Nome do Filiado (Indicador)': item.inviter_name,
          'CPF do Filiado': item.inviter_cpf,
          'Nome do Indicado': item.invited_name,
          'E-mail do Indicado': item.invited_email,
          'CPF do Indicado': item.invited_cpf,
          Status: statusLabels[item.status] || item.status,
          'Data de Indicação': item.indication_date
            ? new Date(item.indication_date).toLocaleDateString('pt-BR')
            : '',
          'Data de Conclusão': item.completion_date
            ? new Date(item.completion_date).toLocaleDateString('pt-BR')
            : '',
          'Data do Número': '',
        });
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Indicações');
    XLSX.writeFile(workbook, 'relatorio-indique-e-concorra.xlsx');
  };

  onDialogClose = () => {
    const from = this.props.location.query.from || 'online';
    this.props.router.push(`/owner/acoes/minhas-atividades?from=${from}`);
  };

  render() {
    const { loading, data } = this.state;

    return (
      <AlertDialogSlide
        label="Relatório - Indique e Concorra"
        visible={true}
        height="95vh"
        onClose={this.onDialogClose}
        maxWidth="lg">
        {loading ? (
          <div className="d-flex justify-content-center mt-5">
            <LoadingProgress />
          </div>
        ) : (
          <div style={{ padding: 16 }}>
            <MaterialGrid
              container
              justifyContent="space-between"
              alignItems="center"
              style={{ marginBottom: 16 }}>
              <MaterialGrid item>
                <Typography variant="h6">Indicações ({data.length})</Typography>
              </MaterialGrid>
              <MaterialGrid item>
                <Tooltip title="Exportar Excel">
                  <IconButton
                    onClick={this.exportToExcel}
                    color="primary"
                    disabled={data.length === 0}>
                    <GetAppIcon />
                  </IconButton>
                </Tooltip>
              </MaterialGrid>
            </MaterialGrid>

            {data.length === 0 ? (
              <Typography variant="body1" color="textSecondary" align="center">
                Nenhuma indicação encontrada para esta atividade.
              </Typography>
            ) : (
              <TableContainer component={Paper} style={{ maxHeight: 'calc(95vh - 200px)' }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Indicador</TableCell>
                      <TableCell>CPF</TableCell>
                      <TableCell>Indicado</TableCell>
                      <TableCell>E-mail</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Data Indicação</TableCell>
                      <TableCell>Números da Sorte</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.inviter_name}</TableCell>
                        <TableCell>{item.inviter_cpf}</TableCell>
                        <TableCell>{item.invited_name}</TableCell>
                        <TableCell>{item.invited_email}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            label={statusLabels[item.status] || item.status}
                            color={item.status === 'completed' ? 'primary' : 'default'}
                          />
                        </TableCell>
                        <TableCell>
                          {item.indication_date
                            ? new Date(item.indication_date).toLocaleDateString('pt-BR')
                            : '-'}
                        </TableCell>
                        <TableCell>
                          {item.lucky_numbers && item.lucky_numbers.length > 0
                            ? item.lucky_numbers.map((n) => n.number).join(', ')
                            : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        )}
      </AlertDialogSlide>
    );
  }
}

ReferralResults.propTypes = {
  auth: PropTypes.shape({ user: PropTypes.shape({ establishments: PropTypes.any }) }),
  location: PropTypes.shape({
    query: PropTypes.shape({ action: PropTypes.any, from: PropTypes.any }),
  }),
  router: PropTypes.shape({ push: PropTypes.func }),
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReferralResults);
